import { render, staticRenderFns } from "./NotificationsDropdown.vue?vue&type=template&id=14c797b8&scoped=true"
import script from "./NotificationsDropdown.vue?vue&type=script&lang=js"
export * from "./NotificationsDropdown.vue?vue&type=script&lang=js"
import style0 from "./NotificationsDropdown.vue?vue&type=style&index=0&id=14c797b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c797b8",
  null
  
)

export default component.exports